/**
 * Vietnam 업로드 기능 접근 규칙 (rule-based).
 *
 * AS-IS: `platform.id ∈ VIETNAM_PLATFORM_IDS`로 판정했다. platform id가 환경마다 다른데
 * `REACT_APP_VIETNAM_PLATFORM_IDS`가 어느 .env에도 정의돼 있지 않아, 기본값 3과 다른 환경에서는
 * 통째로 오작동한다(프론트는 Vietnam으로 안 보내거나, 보냈는데 BE가 403).
 *
 * TO-BE: vendor-* 와 동일하게 `vietnam-*` prefix permission으로 판정한다.
 * 권한 문자열 형식은 기존과 같은 `{menu}:{action}` 이며, prefix가 곧 메뉴 키가 된다.
 *
 * ┌ 대상 페이지 ─────────────────┬ 필요 권한 ──────────────────┐
 * │ /vietnam-uploads (자 CP)      │ vietnam-uploads:read        │
 * │ /vietnam-uploads-admin (모 CP)│ vietnam-uploads-admin:read  │
 * │ /assets/add-vn (업로드 화면)  │ vietnam-uploads:add         │
 * └───────────────────────────────┴─────────────────────────────┘
 *
 * BE Permission 테이블에 위 code가 등록되고 Role에 묶여야 동작한다.
 * 등록 전까지는 accountStore 쪽 platform fallback이 기존 동작을 유지한다.
 */

/** 이 prefix만 보유한 계정 = Vietnam 전용 계정 (vendor-only 판정과 동형). */
export const VIETNAM_PERMISSION_PREFIX = 'vietnam-';

/** 자(CP) 계정 메뉴 키 — 본인 회사 업로드만. */
export const VIETNAM_UPLOADS_MENU = 'vietnam-uploads';

/** 모(CP)/admin 계정 메뉴 키 — 전 회사 업로드 조회. */
export const VIETNAM_UPLOADS_ADMIN_MENU = 'vietnam-uploads-admin';

/** BE에 등록이 필요한 permission code 전체 목록 (Role 세팅 시 참고). */
export const VIETNAM_PERMISSION_CODES = [
  `${VIETNAM_UPLOADS_MENU}:read`,
  `${VIETNAM_UPLOADS_MENU}:add`,
  `${VIETNAM_UPLOADS_ADMIN_MENU}:read`,
];
